module.exports = __webpack_public_path__ + "static/outdoorchapel.572ab1be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outdoorchapel.jpg
// module id = 1229
// module chunks = 227169509118907